/* @flow */
/**
 * VideoSupport is used to determine if a file's content type can be played with
 * the HTML5 <video> tag within a browser.
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Supported_media_formats#Browser_compatibility
 */
import enumerate from 'lib/enumerate';
import userAgent from 'lib/currentUserAgent';
import { TYPES as DISALLOWED_TYPES } from 'lib/AudioSupport';

export const TYPES = enumerate([
  'application/mp4',
  'application/ogg',
  'video/3gpp',
  'video/mpeg',
  'video/mp4',
  'video/ogg',
  'video/quicktime',
  'video/webm',
  'video/x-msvideo',
]);

const TESTS = {
  'video/mp4': 'video/mp4; codecs="avc1.42E01E"',
  'video/ogg': 'video/ogg; codecs="theora"',
  'video/webm': 'video/webm; codecs="vp8, vorbis"',
};

export const TYPE_ALIASES = {
  'application/mp4': 'video/mp4',
  'application/ogg': 'video/ogg',
  'video/3gpp': 'video/mp4',
  'video/mpeg': 'video/mp4',
  'video/quicktime': 'video/mp4',
};

const support = {};
let elem;

export function isSupportedType(type: string) {
  if (userAgent.ie()) {
    return false;
  }

  const resolvedType = TYPE_ALIASES[type] || type;
  if (resolvedType in support) {
    return support[resolvedType];
  }

  if (resolvedType in DISALLOWED_TYPES) {
    return false;
  }

  if (!elem) {
    // FIXME how to test this server side?
    if (typeof document === 'undefined') {
      return false;
    }
    elem = document.createElement('video');
  }

  return (
    support[resolvedType] = typeof elem.canPlayType === 'function' ?
      !!elem.canPlayType(TESTS[resolvedType] || resolvedType).replace(/^no$/, '') :
      false
  );
}



// WEBPACK FOOTER //
// ./src/lib/VideoSupport.js